import { getRequest } from '../services/requestHandler';
import { BsgShoe } from '../models';

export const getBsgShoes = async () => {
  const url = 'bsgshoe/getBsgShoe?activeOnly=true';
  const response = await getRequest<BsgShoe>('GetBsgShoes', url);
  return response;
};
